import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const restrictionsSchema = z.object({
  minDate: z.string(),
  maxDate: z.string(),
});

export const RestrictionsResponseSchema =
  createResponseSchema(restrictionsSchema);
